import { v4 as uuid } from 'uuid';
import _ from 'lodash';
import { axios, baseAxios, fuelPortalAxios } from './interceptor';
import { Ingest, Item } from '../models';
import { FuelEntityType } from '.';

const IngestService = {
  serviceUrl: 'ingests',
  dataUrl: 'data',
  toolsUrl: 'tools',
  //   log: new Log(),

  updateProgressBarValue: 0,
  uploadInprogres: false,
  upload: null,

  /**
   * Upload file
   *
   * @returns {Promise<any>}
   */
  async uploadFile(data: any, uploadUrl?: string): Promise<any> {
    try {
      this.uploadInprogres = true;
      this.upload = baseAxios.CancelToken.source();
      const file = new File([data], data.name, { type: data.type });
      const config = {
        cancelToken: this.upload.token,
        onUploadProgress: (progressEvent) => {
          const totalLength = progressEvent.lengthComputable
            ? progressEvent.total
            : progressEvent.target.getResponseHeader('content-length') ||
              progressEvent.target.getResponseHeader('x-decompressed-content-length');
          if (totalLength !== null) {
            this.updateProgressBarValue = Math.round((progressEvent.loaded * 100) / totalLength);
          }
        },
        headers: {
          'Content-Type': file.type,
        },
      };
      const res = uploadUrl
        ? await baseAxios.put(uploadUrl, file, config)
        : await axios.post(`${this.serviceUrl}/files`, data, config);

      this.updateProgressBarValue = 0;
      this.uploadInprogres = false;
      if (uploadUrl) {
        return res;
      }
      return res.data;
    } catch (err) {
      this.updateProgressBarValue = 0;
      this.uploadInprogres = false;
      if (!baseAxios.isCancel(err)) {
        // store.commit('alert/set', {
        //   message: clientUtils.errorResponseHandler(err, 'uploadFile'),
        //   type: 'error',
        //   position: 'n',
        // });
      }
      throw new Error();
    }
  },
  /**
   * Delete uploaded file for given fileName
   *
   * @returns {Promise<any>}
   */
  async deleteFile(fileName: string): Promise<any> {
    try {
      const res = await axios.delete(this.serviceUrl + '/files/' + fileName);
      return res.data;
    } catch (err) {
      //   store.commit('alert/set', {
      //     message: clientUtils.errorResponseHandler(err, 'deleteFile'),
      //     type: 'error',
      //     position: 'n',
      //   });
      throw new Error();
    }
  },

  /**
   * Create ingest for given metadata
   *
   * @returns {Promise<any>}
   */
  async retryIngest(item: Item): Promise<any> {
    try {
      const itemId = item.id;
      const res = await axios.post(`retryingest/${item.id}`);
      return res.data;
    } catch (err) {
      //   store.commit('alert/set', {
      //     message: clientUtils.errorResponseHandler(err, 'retryIngest'),
      //     type: 'error',
      //     position: 'n',
      //   });
      throw new Error(err);
    }
  },

  /**
   * Create ingest for given metadata
   *
   * @returns {Promise<any>}
   */
  async createIngest(ingests: Ingest[], useFuelPortalIngest: boolean = true): Promise<any> {
    try {
      let res;

      if (useFuelPortalIngest) {
        res = [];
        ingests.forEach(async (ingest) => {
          if (ingest && ingest.item && ingest.item.id) {
            res.push(await fuelPortalAxios.post(`${this.toolsUrl}/startingest/${ingest.item.id}`, ingest.item));
          }
        });
      }
      return res;
    } catch (err) {
      //   store.commit('alert/set', {
      //     message: clientUtils.errorResponseHandler(err, 'createIngest'),
      //     type: 'error',
      //     position: 'n',
      //   });
      throw new Error(err);
    }
  },

  /**
   * Get upload url
   *
   * Added suport to call a POST on this endpoint as is needed for the multipart upload story
   */
  async getMultipartUploadUrl(uploadUrl: string, queryParams: Object, data: Object = null): Promise<any> {
    try {
      let url = uploadUrl;
      if (queryParams != null) {
        const qs = Object.keys(queryParams)
          .map((key) => `${key}=${queryParams[key]}`)
          .join('&');
        url += `?${qs}`;
      }
      let res = null;
      if (data != null) {
        res = await fuelPortalAxios.post(url, data);
      } else {
        res = await fuelPortalAxios.get(url);
      }
      return res ? res.data : null;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  /**
   * Get upload url
   *
   * @returns {Promise<any>}
   */
  async getUploadUrl(id: string, entityType: FuelEntityType, param?: string, extension?: string): Promise<any> {
    try {
      let url = '';
      if (entityType === FuelEntityType.Clip) {
        url =
          param && extension
            ? `${this.dataUrl}/${entityType}/${id}/upload?${param}=${extension}`
            : `${this.dataUrl}/${entityType}/${id}/upload`;
      } else if (entityType === FuelEntityType.Channel || entityType === FuelEntityType.LiveProgram) {
        url = `${this.dataUrl}/${entityType}/${id}/upload/Thumbnail?${param}=${extension}`;
      }
      const res = await fuelPortalAxios.get(url);
      return res.data;
    } catch (err) {
      throw new Error();
    }
  },

  //   /**
  //    * Create Clip
  //    *
  //    * @returns {Promise<Clip>}
  //    */
  //   createClip(fileName: string): Promise<Clip> {
  //     try {
  //       const clip = new Clip(store.state.user.profile.ou_id, store.state.user.profile.sub, fileName);

  //       return this.upsertClip(clip);
  //     } catch (err) {
  //       throw new Error();
  //     }
  //   },

  /**
   * Upsert Clip
   *
   * @returns {Promise<Clip>}
   */
  //   async upsertClip(clip: Clip): Promise<Clip> {
  //     try {
  //       const res = await fuelPortalAxios.post(`${this.dataUrl}/clip`, clip);
  //       return res.data;
  //     } catch (err) {
  //       store.commit('alert/set', {
  //         message: clientUtils.errorResponseHandler(err, 'upsertClip'),
  //         type: 'error',
  //         position: 'n',
  //       });
  //       throw new Error();
  //     }
  //   },

  /**
   * Delete Clip
   *
   * @returns {Promise<Clip>}
   */
  async deleteClip(clipId: string): Promise<void> {
    try {
      await fuelPortalAxios.delete(`${this.dataUrl}/clip/${clipId}`);
    } catch (err) {
      //   store.commit('alert/set', {
      //     message: clientUtils.errorResponseHandler(err, 'deleteClip'),
      //     type: 'error',
      //     position: 'n',
      //   });
      throw new Error();
    }
  },

  /**
   * Gets skeleton for an ingest without an item.
   * @returns Ingest
   */
  getDefaultIngest(ouId, userId): Ingest {
    return {
      id: uuid(),
      userId: userId,
      ouId: ouId,
      item: null,
      createdBy: userId,
      uploadProgress: 0,
    };
  },
};

export { IngestService };
